document.addEventListener('DOMContentLoaded', () => {
	correctVh();
});

window.addEventListener('resize', () => {
	correctVh();
});
function correctVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
}